
import LocalStore from 'store';
import shorthash from '../../../helpers/shorthash';
import Api from '../../../helpers/Api';
import { showError, showSuccess } from '../../../common/A1Alert/A1Alert';

export const SET_RATING = 'SET_RATING';
const setRating = (rating, musicHash) => ({
    type: SET_RATING,
    rating,
    musicHash,
});

export const SET_SETTING_RATING = 'SET_SETTING_RATING';
const setSettingRating = () => ({
    type: SET_SETTING_RATING,
});

export const UNSET_SETTING_RATING = 'UNSET_SETTING_RATING';
const unsetSettingRating = () => ({
    type: UNSET_SETTING_RATING,
});

export const getLocalStoreRating = () => (dispatch) => {
    const musicHash = LocalStore.get('musicHash') || null;
    const rating = LocalStore.get('rating') || null;

    return dispatch(setRating(rating, musicHash));
};

export const rateRating = (rating) => (dispatch, getState) => {
    dispatch(setSettingRating());

    // Note: we currently only allow rating of the live stream(s)

    const state = getState();
    const aovivoBar = state.aovivoBar;
    const musicHash = aovivoBar.Rating.musicHash;
    const currentMetaId = aovivoBar.MediaPlayer.currentStream.metaId;
    const { song, artist, time } = aovivoBar.NowPlaying.musicLive;
    const newHash = shorthash(`${song}-${artist}-${time}`);

    if (newHash === musicHash) {
        // user voted already on this track
        dispatch(unsetSettingRating());

        return showError('Seu voto já foi registrado');
    }

    // send rating to api...
    const query = 'api/v1/aovivoBar/rateSong';
    const data = {
        metaId: currentMetaId,
        song,
        artist,
        rating,
    };

    return Api.progressPost(dispatch, query, data)
        .then((json) => {
            dispatch(unsetSettingRating());

            if (json.status === 'success') {
                if (json.message === 'rating not counted') {
                    // this vote was actually n ot counted due to meta mismatch. See aovivoBarContoller for more information
                    // eslint-disable-next-line no-console
                    console.log('Rating not counted due to meta mismatch');
                }

                LocalStore.set('musicHash', newHash);

                LocalStore.set('rating', rating);

                showSuccess('Seu voto foi registrado com sucesso. Obrigado!');

                return dispatch(setRating(rating, newHash));
            }

            throw `error from server: ${json.message}`;
        }).catch((error) => {
            dispatch(unsetSettingRating());

            showError('Problema na comunicação com servidor, por favor tente novamente em alguns instantes');

            throw `rateRating got error:${error}`;
        });
};
